import copy from './copy'
import track from './track.js'
import citypermission from './citypermission.js'
// 自定义指令
const directives = {
  copy,
  track,
  citypermission
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  },
}